module.exports = __webpack_public_path__ + "static/logo-bd8ffc508bf2ec55e99d03d278a1e270.png";